import { useEffect, useRef } from "react";
import { LenguageTabla } from "../../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";

function HistoricoEstadosSolicitud({ historicoEstados }) {
  const tableRef = useRef();

  useEffect(() => {
    $.fn.dataTable.ext.errMode = "throw";
    $.fn.dataTable.moment("DD/MM/YYYY hh:mm A");

    $(tableRef.current).DataTable({
      language: LenguageTabla,
      processing: true,
      destroy: true,
      data: historicoEstados,
      columns: [
        {
          title: "Codigos",
          data: "estado.codigo",
        },
        {
          title: "Estado",
          data: "estado.descripcion",
        },
        {
          title: "Registrado por",
          data: "usuarioSolicitud.nombreCompleto",
        },
        {
          title: "Fecha",
          data: "fechaEstado",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY hh:mm A") : "";
          },
        },
        {
          title: "Comentario",
          data: "comentario",
        },
      ],
      order: [0, "asc"],
      columnDefs: [
        {
          targets: [0],
          visible: false,
          orderable: true,
        },
      ],
    });
  }, [historicoEstados]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">
          Histórico de Estados de la Solicitud
        </h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default HistoricoEstadosSolicitud;
